import { Box, Flex } from '@chakra-ui/react'
import { ReactChild, useContext, useEffect, useRef } from 'react'
import { Header } from '../../../components/Header'
import { Sidebar } from '../../../components/Sidebar'
import { ConfigurationContext } from '../../../context/ConfigurationContext'
import { useAuth } from '../../../context/AuthContext'
import { Notifications } from '../../../Interfaces/notifications'
import { api } from '../../../services/api'
import { cookies } from '../../../utils/cookies'

interface AuxProps {
  children: ReactChild | React.ReactNode
  openLayout: boolean
}

export function Default({ children, openLayout }: AuxProps) {
  const { populateNotifications } = useContext(ConfigurationContext)
  const { hasPermission } = useAuth()
  const pollingTimeoutRef = useRef<NodeJS.Timeout | null>(null)
  const isFetchingRef = useRef(false)

  useEffect(() => {
    let isUnmounted = false

    const scheduleNextPolling = () => {
      if (isUnmounted) return

      if (pollingTimeoutRef.current) {
        clearTimeout(pollingTimeoutRef.current)
      }

      pollingTimeoutRef.current = setTimeout(() => {
        void checkNotifications()
      }, 60000)
    }

    const checkNotifications = async () => {
      if (isUnmounted || isFetchingRef.current) return

      const canFetchNotifications = !!cookies.get('@AXAuth:Token') && hasPermission('stock.manage')

      if (!canFetchNotifications) {
        scheduleNextPolling()
        return
      }

      isFetchingRef.current = true

      try {
        const { data } = await api.get<Notifications[]>('/raw-material-notifications')
        const notifications = Array.isArray(data) ? data : data ? [data] : []
        populateNotifications(notifications)
      } catch (error) {
        console.error('Erro ao carregar notificações:', error)
        populateNotifications([])
      } finally {
        isFetchingRef.current = false
        scheduleNextPolling()
      }
    }

    void checkNotifications()

    return () => {
      isUnmounted = true
      if (pollingTimeoutRef.current) {
        clearTimeout(pollingTimeoutRef.current)
      }
      isFetchingRef.current = false
    }
  }, [hasPermission])

  return (
    <>
      {openLayout ? (
        <>
          <Header />
          <Flex w="100%" my="6" mx="auto" maxWidth={1700} px="6">
            <Sidebar />

            <Box flex="1" borderRadius="8" bg="gray.800" p="8">
              {children}
            </Box>
          </Flex>
        </>
      ) : (
        <Flex w="100%" maxWidth={1700}>
          <Box flex="1" borderRadius="8" bg="gray.800" p="8">
            {children}
          </Box>
        </Flex>
      )}
    </>
  )
}
